
import { defineComponent } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import { getCurrentUser } from "@/utils/index";
import {
  getAccountInfo,
  getMoreAccountInfo,
  getEDPLANPairCount,
  getCarfundMonitor,
} from "@/api/dashboard";

import { getCSSVariableValue } from "@/assets/ts/_utils";
import DashboardTabNavigator from "@/components/dashboard/DashboardTabNavigator.vue";

export default defineComponent({
  name: "accountinfo",
  components: {
    DashboardTabNavigator,
  },
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      user: {},
      summary1: {},
      isLoading: true,
      pt: "",
      isShowMore: true,
      summary2: {},
      ccode: -1,
      edplanpairs: 0,
      maxUturn: 0,
      series: [0],
      loadingMonitor: false,
      carfundMonitor: {},
      packageType: "",
      chartHeight: 320,
    };
  },
  watch: {
    ccode() {
      this.$nextTick(() => this.updateCarFundChartSize());
    },
    isLoading(value: boolean) {
      if (!value) {
        this.$nextTick(() => this.updateCarFundChartSize());
      }
    },
  },
  computed: {
    chartOptions(): Record<string, unknown> {
      const baseColor = getCSSVariableValue("--bs-primary");
      const lightColor = getCSSVariableValue("--bs-light-primary");
      const labelColor = getCSSVariableValue("--bs-gray-700");
      // Cast: Vue TS sometimes narrows `this` to only computed keys in this file
      const chartHeight = Number((this as any).chartHeight) || 320;
      const isMobile = window.innerWidth <= 767 || chartHeight <= 260;

      return {
        chart: {
          fontFamily: "inherit",
          height: chartHeight,
          width: "100%",
          type: "radialBar",
          parentHeightOffset: 0,
          sparkline: {
            enabled: false,
          },
        },
        plotOptions: {
          radialBar: {
            hollow: {
              margin: 0,
              size: isMobile ? "58%" : "65%",
            },
            dataLabels: {
              showOn: "always",
              name: {
                show: false,
                fontWeight: "700",
              },
              value: {
                color: labelColor,
                fontSize: isMobile ? "22px" : "30px",
                fontWeight: "700",
                offsetY: isMobile ? 8 : 12,
                show: true,
                formatter: function (val) {
                  return val + "%";
                },
              },
            },
            track: {
              background: lightColor,
              strokeWidth: "100%",
            },
          },
        },
        colors: [baseColor],
        stroke: {
          lineCap: "round",
        },
        labels: ["Progress"],
        grid: {
          padding: {
            top: 0,
            right: 8,
            bottom: 0,
            left: 8,
          },
        },
      };
    },
  },
  mounted() {
    this.user = getCurrentUser();
    this.packageType = String(localStorage.getItem("pVaAcNkPaOgGeItRyEpAeL"));

    this.getPT();
    this.getAccountInfo();
    this.getEDPLANPairCountNow();
    this.updateCarFundChartSize();
    window.addEventListener("resize", this.updateCarFundChartSize);

    console.log(this.packageType);
    if (this.packageType != "REGV4Z01") {
      this.getCarfund_Monitor();
    }
  },
  beforeUnmount() {
    window.removeEventListener("resize", this.updateCarFundChartSize);
  },
  methods: {
    updateCarFundChartSize() {
      const isMobile = window.innerWidth <= 767;

      this.$nextTick(() => {
        const el = this.$refs.carFundChart as HTMLElement | undefined;
        const containerWidth = el?.clientWidth || 0;

        if (containerWidth > 0) {
          // Keep the circle inside the column; seq-card uses overflow:hidden
          const maxHeight = isMobile ? 260 : 360;
          this.chartHeight = Math.max(200, Math.min(maxHeight, containerWidth - 16));
          return;
        }

        this.chartHeight = isMobile ? 260 : 320;
      });
    },

    async getCarfund_Monitor() {
      this.loadingMonitor = true;

      var self = this;

      let param = { x: "x" };
      const response = await getCarfundMonitor(param);

      if (response.data.carfundMonitor !== null && response.data.carfundMonitor !== undefined) {
        this.carfundMonitor = response.data.carfundMonitor;
        this.series = [response.data.carfundMonitor.porsyento];
      }

      this.loadingMonitor = false;
    },

    async getAccountInfo() {
      this.isLoading = true;
      const response = await getAccountInfo();

      if (response.data.summary1 !== null && response.data.summary1 !== undefined) {
        this.summary1 = response.data.summary1;
        this.ccode = response.data.ccode;
      }

      this.isLoading = false;
    },
    async showMoreAccountInfo() {
      this.isLoading = true;
      const response = await getMoreAccountInfo();

      if (response.data.summary1 !== null && response.data.summary1 !== undefined) {
        this.summary2 = response.data.summary1;
        this.isShowMore = false;
      }

      this.isLoading = false;
    },
    async getEDPLANPairCountNow() {
      this.isLoading = true;
      const response = await getEDPLANPairCount();
      console.log(response.data);

      if (response.data.edplanpairs !== null && response.data.edplanpairs !== undefined) {
        this.edplanpairs = response.data.edplanpairs;
        this.maxUturn = response.data.maxUturn;
      }

      this.isLoading = false;
    },
    async getPT() {
      this.pt = String(localStorage.getItem("pt"));
    },
  },
});
